import { AfterViewInit, Component, Input } from "@angular/core";
import { EdiSummaryFixingsLineItem } from "@interfaces/ediSummaryFixingsLineItem.interface";

@Component({
	moduleId: module.id,
	selector: "ediSummaryFixingsGridDetails",
	styleUrls: ["ediSummaryFixingsGridDetails.css"],
	templateUrl: "ediSummaryFixingsGridDetails.html"
})
export class EdiSummaryFixingsDetailsComponent implements AfterViewInit {
	@Input() lineItemData = "";
	lineItems: EdiSummaryFixingsLineItem[] = [];
  
	ngAfterViewInit() {
		this.lineItems = JSON.parse(this.lineItemData);
	}
}